import { useState, useEffect, useContext, useRef } from "react";
import { SearchContext, KBContext } from "../index";
import { useSearchParams } from "react-router-dom";
import { useArticleSearchSuggestions } from "../../hooks/apis";
import { useDebouncedValue } from "../../hooks/useDebouncedValue";
import { handleGainSightEventForSearchResults, KB_WEBSITE_GAINSIGHT_EVENTS, sendGainsightEvent } from "../../gainSightIntegration";
import { isFeatureEnabled } from "../../utils";
import { FTR_KB_AI_SEARCH } from "../../Constants";

export default function ArticleProvider(props) {
  const [searchInput, setSearchInput] = useState("");
  const [forceHideList, setForceHideList] = useState(false);
  const [searchParams] = useSearchParams();
  const productParam = searchParams.get("product");

  const { availableFeatures } = useContext(KBContext);
  const isAISearchEnabled = isFeatureEnabled(FTR_KB_AI_SEARCH, availableFeatures);

  const debouncedSearchTerm = useDebouncedValue(searchInput, 300);
  const {
    data: searchList = false,
    isLoading: loading,
    refetch: refetchSearch,
  } = useArticleSearchSuggestions(debouncedSearchTerm, productParam);

  const setSearchList = (val) => {
    if (val === false || (Array.isArray(val) && val.length === 0)) {
      setForceHideList(true);
    }
  };

  useEffect(() => {
    if (searchInput.length > 0) setForceHideList(false);
  }, [searchInput]);

  const prevDataRef = useRef(undefined);
  useEffect(() => {
    if (debouncedSearchTerm.length < 2) return;
    const articles = Array.isArray(searchList) ? searchList : [];
    if (prevDataRef.current !== searchList) {
      prevDataRef.current = searchList;
      if (articles.length > 0) {
        const top3Slugs = articles.slice(0, 3).map((a) => a.slug);
        handleGainSightEventForSearchResults({
          search_query: debouncedSearchTerm,
          results_count: articles.length,
          top_result_id: articles[0]?.slug || "",
          top_3_result_slugs: top3Slugs,
          search_latency_ms: 0,
        });
      } else {
        sendGainsightEvent(KB_WEBSITE_GAINSIGHT_EVENTS.KB_SEARCH_ZERO_RESULTS, {
          search_query: debouncedSearchTerm,
        });
      }
    }
  }, [debouncedSearchTerm, searchList]);

  useEffect(() => {
    if (debouncedSearchTerm.length >= 2) {
      sendGainsightEvent(KB_WEBSITE_GAINSIGHT_EVENTS.KB_SEARCH_SUBMITTED, {
        search_query: debouncedSearchTerm,
      });
    }
  }, [debouncedSearchTerm]);

  const displayList =
    searchInput.length === 0 || forceHideList ? false : searchList;

  return (
    <SearchContext.Provider
      value={{
        searchList: displayList,
        setSearchInput,
        setSearchList,
        searchInput,
        triggerSearch: () => refetchSearch(),
        loading,
      }}
    >
      {props.children}
    </SearchContext.Provider>
  );
}
